/**
 * @generated SignedSource<<540bb42193bbb0d4e39b3e2a9142f4a4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WorkspaceRoutineOccasionStoresListItem_routineWorkspaceOccasion$data = {
  readonly occasion: {
    readonly issueCount: number;
    readonly registeredIssueCount: number;
    readonly sequenceNumber: number;
    readonly " $fragmentSpreads": FragmentRefs<"RoutineOccasionStatusCircle_RoutineOccasion">;
  };
  readonly store: {
    readonly id: string;
    readonly name: string;
    readonly timezone: string;
  };
  readonly " $fragmentType": "WorkspaceRoutineOccasionStoresListItem_routineWorkspaceOccasion";
};
export type WorkspaceRoutineOccasionStoresListItem_routineWorkspaceOccasion$key = {
  readonly " $data"?: WorkspaceRoutineOccasionStoresListItem_routineWorkspaceOccasion$data;
  readonly " $fragmentSpreads": FragmentRefs<"WorkspaceRoutineOccasionStoresListItem_routineWorkspaceOccasion">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WorkspaceRoutineOccasionStoresListItem_routineWorkspaceOccasion",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Store",
      "kind": "LinkedField",
      "name": "store",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "timezone",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "RoutineOccasion",
      "kind": "LinkedField",
      "name": "occasion",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "RoutineOccasionStatusCircle_RoutineOccasion"
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "registeredIssueCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sequenceNumber",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "issueCount",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "RoutineWorkspaceOccasionEdge",
  "abstractKey": null
};

(node as any).hash = "528e6cfdfc3a3d017a2b8724b6d6aa92";

export default node;
